"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromInfoToAddress = exports.isAddressValid = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const common_scripts_1 = require("@ckb-lumos/common-scripts");
/**
 * Check if the target address is valid.
 */
function isAddressValid(address, config) {
    try {
        lumos_1.helpers.parseAddress(address, { config });
        return true;
    }
    catch {
        return false;
    }
}
exports.isAddressValid = isAddressValid;
/**
 * Convert a FromInfo to a CKB address.
 */
function fromInfoToAddress(fromInfo, config) {
    if (typeof fromInfo === 'string' && isAddressValid(fromInfo)) {
        return fromInfo;
    }
    const parsed = (0, common_scripts_1.parseFromInfo)(fromInfo, { config });
    return lumos_1.helpers.encodeToAddress(parsed.fromScript, { config });
}
exports.fromInfoToAddress = fromInfoToAddress;
//# sourceMappingURL=address.js.map